export const CALL_STICKER_HEIGHT = 50;
